export const pageRoutes = {
  /* Authenticate */
  LOGIN: "/:branch_id?",
  REGISTER: "/register/:id?",
  FORGOTPASS: "/forgot-password",
  ACCOUNTVERIFIY: "/account-verify",

  /* Applicant */
  EXAM: "/assessment/exam/:id?",
  PEXAM: "/personality-exam/:id?",
  EXAMDASHBOARD: "/assessment",
  APPLICANT: "/applicant/:tab?",
  USERFORM: "/applicant/application-form",
  VIDEOINTERVIEW: "/assessment/video-interview",
  ONBOARDINGEXAM: "/onboarding-exam/:id?",
};
